import { useInfiniteQuery } from "@tanstack/react-query";
import {
  getFeedShopRecommendations,
  getFeedPeopleRecommendations,
} from "../utility/httpActions/feedActions";
import useAuthentication from "./useAuthentication";

export const RECOMMENDATIONS_PAGE_SIZE = 8;

export const useInfiniteShopRecommendations = () =>
  useInfiniteQuery({
    queryKey: ["feedShopRecommendations"],
    queryFn: ({ pageParam }) => getFeedShopRecommendations(pageParam),
    initialPageParam: [],
    getNextPageParam: (lastPage, _allPages, lastPageParam) =>
      (lastPage.shops?.length ?? 0) < RECOMMENDATIONS_PAGE_SIZE
        ? undefined
        : [...lastPageParam, ...lastPage.shops.map((s) => s.id)],
    staleTime: 5 * 60 * 1000,
  });

export const useInfinitePeopleRecommendations = () => {
  const { isLoggedIn } = useAuthentication();
  return useInfiniteQuery({
    queryKey: ["feedPeopleRecommendations"],
    queryFn: ({ pageParam }) => getFeedPeopleRecommendations(pageParam),
    initialPageParam: [],
    getNextPageParam: (lastPage, _allPages, lastPageParam) =>
      (lastPage.people?.length ?? 0) < RECOMMENDATIONS_PAGE_SIZE
        ? undefined
        : [...lastPageParam, ...lastPage.people.map((p) => p.id)],
    staleTime: 5 * 60 * 1000,
    enabled: isLoggedIn,
  });
};
